import { LayingPattern } from 'CommonData/poco/index';

export class LayingPatternMapper {
    public static map(data: any): Array<LayingPattern> {
        if (!data) {
            throw 'No data for mapper: LayingPatternMapper';
        }

        return data.layingPatterns.map((p: any) =>
            new LayingPattern({
                id: p.id,
                name: p.name,
                swatchImageUrl: `${data.patternSwatchImageUrl}${p.swatchImageUrl}`
            })
        );
    }
} 